import { actionCreator } from 'utils';
import * as ConfigurationTypes from '../types/configurationTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    offset: 0,
    limit: 10,
    filters: {
        'configuration_property.carrier_id': [],
        'configuration_property.property_value_id': [],
        configuration_type: [],
        'name.translate': '',
    },
    searchCarrier: {
        loading: false,
        data: [],
    },
    searchPropertyValue: {
        loading: false,
        data: [],
    },
    checked: {
        loading: false,
        ids: [],
    },
    add: {
        loading: false,
        error: false,
        success: false,
        carriers: {
            loading: false,
            error: false,
            data: [],
        },
        propertyValues: {
            loading: false,
            error: false,
            data: [],
        },
    },
    edit: {
        loading: false,
        error: false,
        data: null,
        carriers: {
            loading: false,
            error: false,
            data: [],
        },
    },
    bulk: {
        loading: false,
        finish: false,
        progress: [],
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case ConfigurationTypes.LOAD_CARRIERS_FOR_CONFIGURATION:
        return Object.assign({}, state, {
            [action.key]: Object.assign({}, state[action.key], {
                carriers: {
                    ...state.add.carriers,
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(ConfigurationTypes.LOAD_CARRIERS_FOR_CONFIGURATION, 'res'):
        return Object.assign({}, state, {
            [action.key]: Object.assign({}, state[action.key], {
                carriers: {
                    ...state.add.carriers,
                    loading: false,
                    data: action.data,
                },
            }),
        });

    case actionCreator(ConfigurationTypes.LOAD_CARRIERS_FOR_CONFIGURATION, 'err'):
        return Object.assign({}, state, {
            [action.key]: Object.assign({}, state[action.key], {
                carriers: {
                    ...state.add.carriers,
                    loading: false,
                    error: true,
                },
            }),
        });

    case ConfigurationTypes.LOAD_PROPERTY_VALUES_FOR_CONFIGURATION:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                propertyValues: {
                    ...state.add.propertyValues,
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(ConfigurationTypes.LOAD_PROPERTY_VALUES_FOR_CONFIGURATION, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                propertyValues: {
                    ...state.add.propertyValues,
                    loading: false,
                    data: action.data,
                },
            }),
        });

    case actionCreator(ConfigurationTypes.LOAD_PROPERTY_VALUES_FOR_CONFIGURATION, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                propertyValues: {
                    ...state.add.propertyValues,
                    loading: false,
                    error: true,
                },
            }),
        });

    case ConfigurationTypes.ADD_NEW_CONFIGURATION:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ConfigurationTypes.ADD_NEW_CONFIGURATION, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(ConfigurationTypes.ADD_NEW_CONFIGURATION, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: false,
                success: false,
                error: action.error,
            }),
        });

    case ConfigurationTypes.UPDATE_TRANSLATE_CONFIGURATION:
        return Object.assign({}, state, {
            [action.key]: Object.assign({}, state[action.key], {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ConfigurationTypes.UPDATE_TRANSLATE_CONFIGURATION, 'res'):
        return Object.assign({}, state, {
            [action.key]: Object.assign({}, state[action.key], {
                loading: action.loading,
                success: action.success,
            }),
        });

    case actionCreator(ConfigurationTypes.UPDATE_TRANSLATE_CONFIGURATION, 'err'):
        return Object.assign({}, state, {
            [action.key]: Object.assign({}, state[action.key], {
                loading: action.loading,
                success: action.success,
                error: true,
            }),
        });

    case ConfigurationTypes.LOAD_EDITABLE_CONFIGURATION:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ConfigurationTypes.LOAD_EDITABLE_CONFIGURATION, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: action.data,
                carriers: Object.assign({}, state.edit.carriers, {
                    data: action.data.carrier,
                }),
            }),
        });

    case actionCreator(ConfigurationTypes.LOAD_EDITABLE_CONFIGURATION, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: action.error,
            }),
        });


    case ConfigurationTypes.EDIT_CONFIGURATION:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ConfigurationTypes.EDIT_CONFIGURATION, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                success: action.success,
                data: null,
            }),
        });

    case actionCreator(ConfigurationTypes.EDIT_CONFIGURATION, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                success: false,
                error: action.error,
            }),
        });

    case ConfigurationTypes.LOAD_CONFIGURATIONS:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(ConfigurationTypes.LOAD_CONFIGURATIONS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(ConfigurationTypes.LOAD_CONFIGURATIONS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case ConfigurationTypes.SET_CONFIGURATION_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(ConfigurationTypes.SET_CONFIGURATION_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case ConfigurationTypes.SET_CONFIGURATION_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case ConfigurationTypes.SET_CONFIGURATION_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case ConfigurationTypes.LOAD_CARRIERS_FOR_CONFIGURATION_FILTER:
        return Object.assign({}, state, {
            searchCarrier: {
                ...state.searchCarrier,
                loading: true,
            },
        });

    case actionCreator(ConfigurationTypes.LOAD_CARRIERS_FOR_CONFIGURATION_FILTER, 'res'):
        return Object.assign({}, state, {
            searchCarrier: {
                ...state.searchCarrier,
                loading: false,
                data: action.data,
            },
        });

    case actionCreator(ConfigurationTypes.LOAD_CARRIERS_FOR_CONFIGURATION_FILTER, 'err'):
        return Object.assign({}, state, {
            searchCarrier: {
                ...state.searchCarrier,
                loading: false,
            },
        });

    case ConfigurationTypes.LOAD_PROPERTY_VALUES_FOR_CONFIGURATION_FILTER:
        return Object.assign({}, state, {
            searchPropertyValue: {
                ...state.searchPropertyValue,
                loading: true,
            },
        });

    case actionCreator(ConfigurationTypes.LOAD_PROPERTY_VALUES_FOR_CONFIGURATION_FILTER, 'res'):
        return Object.assign({}, state, {
            searchPropertyValue: {
                ...state.searchPropertyValue,
                loading: false,
                data: action.data,
            },
        });

    case actionCreator(ConfigurationTypes.LOAD_PROPERTY_VALUES_FOR_CONFIGURATION_FILTER, 'err'):
        return Object.assign({}, state, {
            searchPropertyValue: {
                ...state.searchPropertyValue,
                loading: false,
            },
        });

    case ConfigurationTypes.RESET_CARRIERS_PROPERTY_VALUES_FOR_CONFIGURATION:
        return Object.assign({}, state, {
            searchPropertyValue: {
                ...state.searchPropertyValue,
                loading: false,
                data: [],
            },
            searchCarrier: {
                ...state.searchCarrier,
                loading: false,
                data: [],
            },
            add: {
                ...state.add,
                carriers: {
                    ...state.add.carriers,
                    loading: false,
                    error: false,
                    data: [],
                },
                propertyValues: {
                    ...state.add.propertyValues,
                    loading: false,
                    data: [],
                },
            },
            edit: {
                ...state.edit,
                carriers: {
                    ...state.edit.carriers,
                    loading: false,
                    data: [],
                },
            },
        });

    case ConfigurationTypes.RESET_CONFIGURATION_FILTERS:
        return Object.assign({}, state, {
            filters: initState.filters,
        });

    case ConfigurationTypes.TOGGLE_CONFIGURATION_STATUS:
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: action.id,
            },
        });

    case actionCreator(ConfigurationTypes.TOGGLE_CONFIGURATION_STATUS, 'res') || actionCreator(ConfigurationTypes.TOGGLE_CONFIGURATION_STATUS, 'err'):
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: false,
            },
        });

    case ConfigurationTypes.SET_CHECKED_CONFIGURATIONS:
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                ids: action.ids,
            },
        });

    case ConfigurationTypes.BULK_CHECKED_CONFIGURATIONS:
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: action.ids,
            },
        });

    case actionCreator(ConfigurationTypes.BULK_CHECKED_CONFIGURATIONS, 'res'):
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: false,
                ids: action.ids,
            },
        });

    case actionCreator(ConfigurationTypes.BULK_CHECKED_CONFIGURATIONS, 'err'):
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: false,
            },
        });

    case ConfigurationTypes.ADD_BULK_CONFIGURATIONS:
        return Object.assign({}, state, {
            bulk: {
                ...state.bulk,
                loading: true,
            },
        });

    case ConfigurationTypes.UPDATE_PROGRESS_OF_BULK_CONFIGURATIONS:
        return Object.assign({}, state, {
            bulk: {
                ...state.bulk,
                progress: [
                    ...state.bulk.progress,
                    action.configuration,
                ],
            },
        });

    case ConfigurationTypes.FINISH_ADDING_BULK_CONFIGURATIONS:
        return Object.assign({}, state, {
            bulk: {
                ...state.bulk,
                loading: false,
                finish: true,
            },
        });

    case ConfigurationTypes.RESET_BULK_CONFIGURATIONS:
        return Object.assign({}, state, {
            bulk: {
                ...state.bulk,
                finish: false,
                progress: [],
            },
        });


    default:
        return state;
    }
}
